/* GemofU wishlist — saved in the shopper's own browser (localStorage).
   No app, no account needed. Exposes window.GouWishlist.
   Loaded site-wide from layout/theme.liquid. */
(function () {
  if (window.GouWishlist) return;

  var KEY = 'gou_wishlist_v1';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3l-1.5-1.36C5.4 14.36 2 11.28 2 7.5 2 4.42 4.42 2 7.5 2c1.74 0 3.41.81 4.5 2.09C13.09 2.81 14.76 2 16.5 2 19.58 2 22 4.42 22 7.5c0 3.78-3.4 6.86-8.5 11.44L12 20.3z"/></svg>';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) { return []; }
  }

  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
  }

  var API = {
    all: read,
    has: function (handle) { return read().indexOf(handle) !== -1; },
    count: function () { return read().length; },
    toggle: function (handle) {
      var arr = read();
      var i = arr.indexOf(handle);
      if (i === -1) { arr.unshift(handle); } else { arr.splice(i, 1); }
      write(arr);
      sync();
      return i === -1;
    },
    remove: function (handle) {
      var arr = read();
      var i = arr.indexOf(handle);
      if (i !== -1) { arr.splice(i, 1); write(arr); sync(); }
    }
  };

  function sync() {
    var n = API.count();
    document.querySelectorAll('[data-gou-wish-count]').forEach(function (el) {
      var text = n > 0 ? String(n) : '';
      if (el.textContent !== text) el.textContent = text;
      el.setAttribute('data-empty', n === 0 ? 'true' : 'false');
    });
    document.querySelectorAll('[data-gou-wish]').forEach(function (btn) {
      var on = API.has(btn.getAttribute('data-gou-wish'));
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
    document.dispatchEvent(new CustomEvent('gou:wishlist:change', { detail: { count: n } }));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-gou-wish]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    API.toggle(btn.getAttribute('data-gou-wish'));
  });

  /* Build the header heart. Done in JS so no Forge header file is modified.
     Forge nests its cart trigger inside <li class="header__cart-links--cart">
     within <ul class="header__cart-links__wrapper">. We insert a SIBLING <li>
     before that one - putting the heart alongside search / account / cart
     rather than inside the cart item, which made the icons stack.
     The mobile header has the same shape under a different class, so both get
     a heart; the mobile one is sized to match that row's icons. */
  function makeLink() {
    var a = document.createElement('a');
    a.href = '/pages/wishlist';
    a.className = 'gou-wish-header';
    a.setAttribute('data-gou-wish-header', '');
    a.setAttribute('aria-label', 'Wishlist');
    a.innerHTML = HEART + '<span class="gou-wish-header__count" data-gou-wish-count data-empty="true"></span>';
    return a;
  }

  function injectInto(cartLink) {
    if (!cartLink) return false;
    var li = cartLink.closest ? cartLink.closest('li') : null;
    if (li && li.parentNode && li.parentNode.tagName === 'UL') {
      if (li.parentNode.querySelector('[data-gou-wish-header]')) return true;
      var wrap = document.createElement('li');
      wrap.className = 'gou-wish-li';
      /* The mobile header's icons run larger than the desktop row's, so the
         heart is tagged and sized separately rather than inheriting. */
      if (li.className.indexOf('mobile-header') !== -1 || li.closest('.section-header__mobile')) {
        wrap.className += ' gou-wish-li--mobile';
      }
      wrap.appendChild(makeLink());
      li.parentNode.insertBefore(wrap, li);
      return true;
    }
    return false;
  }

  function injectHeaderLink() {
    /* The mobile header is a <section>, not <header>/<nav>, so it has to be
       named explicitly - without this the heart only ever appeared on
       desktop and phone shoppers had no way back to their saved items. */
    var carts = document.querySelectorAll(
      '.header__cart-links__wrapper a[href*="/cart"],' +
      '.mobile-header__cart-links--cart a[href*="/cart"],' +
      '[class*="cart-links--cart"] a[href*="/cart"],' +
      'header a[href*="/cart"], nav a[href*="/cart"]'
    );
    var done = false;
    for (var i = 0; i < carts.length; i++) {
      if (injectInto(carts[i])) { done = true; }
    }
    if (done) sync();
  }

  /* Wishlist page rendering */
  function money(cents) {
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency', currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'INR',
        maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (e) { return '₹' + Math.round(cents / 100); }
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* The page used to be rebuilt on every "wishlist changed" event, and that
     event also fires from the page-wide DOM watcher below. Adding the cards
     changed the DOM, which fired the event, which wiped the grid before the
     cards could land - so the page always looked empty. It now redraws only
     when the saved list itself is different from what is on screen, and a
     slower, older draw can never write into a newer one. */
  var shownKey = null;
  var drawId = 0;

  function renderPage(force) {
    var root = document.getElementById('gou-wishlist-page');
    if (!root) return;
    var handles = API.all();
    var key = handles.join('|');
    if (!force && key === shownKey) return;
    shownKey = key;
    var myDraw = ++drawId;

    if (!handles.length) {
      root.innerHTML =
        '<div class="gou-wish-empty">' + HEART +
        '<p>Your wishlist is empty.</p>' +
        '<a class="gou-wish-cta" href="/collections/all">Start browsing</a>' +
        '</div>';
      return;
    }

    if (!root.querySelector('[data-grid]')) {
      root.innerHTML = '<div class="gou-wish-grid" data-grid aria-busy="true"></div>';
    }

    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return undefined; });
    })).then(function (products) {
      if (myDraw !== drawId) return;
      var gone = [];
      var html = '';
      products.forEach(function (p, i) {
        var handle = handles[i];
        if (p === null) { gone.push(handle); return; }
        if (!p) return;
        var img = p.featured_image || (p.images && p.images[0]) || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        var url = '/products/' + encodeURIComponent(handle);
        html +=
          '<article class="gou-wish-card">' +
            '<a class="gou-wish-card__img" href="' + url + '">' +
              (img ? '<img src="' + esc(img) + (img.indexOf('?') === -1 ? '?' : '&') + 'width=600" alt="' + esc(p.title) + '" loading="lazy">' : '<span class="gou-wish-card__noimg"></span>') +
            '</a>' +
            '<button type="button" class="gou-wish-card__remove" data-gou-wish="' + esc(handle) + '" aria-pressed="true" aria-label="Remove from wishlist">&times;</button>' +
            '<p class="gou-wish-card__title"><a href="' + url + '">' + esc(p.title) + '</a></p>' +
            '<p class="gou-wish-card__price">' + money(p.price) + (p.available ? '' : ' <em>Sold out</em>') + '</p>' +
          '</article>';
      });
      var grid = root.querySelector('[data-grid]');
      if (!grid) {
        root.innerHTML = '<div class="gou-wish-grid" data-grid></div>';
        grid = root.querySelector('[data-grid]');
      }
      grid.innerHTML = html;
      grid.removeAttribute('aria-busy');
      /* Products that no longer exist are dropped from the saved list. */
      gone.forEach(function (h) { API.remove(h); });
    });
  }

  document.addEventListener('gou:wishlist:change', function () {
    if (document.getElementById('gou-wishlist-page')) renderPage(false);
  });

  /* Coming back to the page (back button, another tab changed the list). */
  window.addEventListener('pageshow', function () { renderPage(false); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { sync(); } });

  function init() { injectHeaderLink(); sync(); renderPage(true); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  /* Re-run after Forge swaps grid or header content (filters, pagination, quick view) */
  var pending = null;
  var mo = new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; injectHeaderLink(); sync(); }, 150);
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });

  window.GouWishlist = API;
})();
